import { Component, Input, Output, EventEmitter, OnInit, ElementRef, ViewChild, OnChanges, SimpleChanges  } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UserGroup} from '../../../_models/user_group';
import { Zone} from '../../../_models/zone';

import { DbTransform } from '../../../_helpers/db.transform';

import * as fromSortableColumn from '../../../sortableColumn/sortableColumn.function';


@Component({
  selector: 'app-userGroup',
  templateUrl: './userGroup-list.component.html'
})
export class UserGroupListComponent implements OnInit {

  dbt: DbTransform;

  setTimeout_aux: number;

  title: string;
  subtitle: string;

  deleteModal: boolean;

  searchUserGroupForm: FormGroup;

  @ViewChild('searchButton',  {static: true}) searchButton: ElementRef;

  @Input() userGroups: UserGroup[];
  @Input() currentUserGroup: UserGroup;
  @Input() zoneList: Zone[];
  @Input() filterFields: any;
  @Output() searchUserGroups = new EventEmitter<any>();
  @Output() setCurrentUserGroup = new EventEmitter<UserGroup>();
  @Output() deleteUserGroup = new EventEmitter<UserGroup>();

  constructor(
    public router: Router,
    private formBuilder: FormBuilder
  ) {}

  // convenience getter for easy access to form fields
  get f() { return this.searchUserGroupForm.controls; }

  ngOnInit() {

    this.dbt = new DbTransform(localStorage.getItem('enviroment')); //this.globals.currentUserEnviroment);

    this.setTimeout_aux = 1000;

    this.title = 'Módulo  Grupos de Usuarios';
    this.subtitle = 'Listado Grupos de Usuarios';

    this.deleteModal = false;

    // Colocamos inicialmente el foco en el botón de búsqueda.
    this.searchButton.nativeElement.focus();

    this.searchUserGroupForm = this.formBuilder.group({
      f_name: this.filterFields['f_name'],
      f_description: this.filterFields['f_description'],
      f_id: this.filterFields['f_id'],
      f_activated: this.filterFields['f_activated']
    });
  } // End function ngOnInit

  // NOTA: función que coge los parámetros del formulario y los "emite" fuera.
  buttonGetUserGroupList(): void {
    console.log('-->--> Pulsado botón Buscar UserGroup.');

    this.searchUserGroups.emit(this.searchUserGroupForm.value);
  } // End function buttonGetUserGroupList

  buttonCreateUserGroup() {
    console.log('CurrentUserGroup =>');
    console.log(this.currentUserGroup);

    this.setCurrentUserGroup.emit(null);
    this.router.navigate(['/userGroup-edit']);
  } // End function buttonCreateUserGroup

  buttonSetCurrentUserGroup(userGroup: UserGroup | null) {
    console.log('-> -> Seleccionado UserGroup:');
    console.log(userGroup);

    this.setCurrentUserGroup.emit(userGroup);

    this.router.navigate(['/userGroup-edit']);

    // setTimeout(() => {this.router.navigate(['/userGroup-edit'])}, this.setTimeout_aux);

  } // End function buttonSetCurrentUserGroup

  buttonDeleteUserGroup(userGroup: UserGroup) {
    console.log('-> -> Borrar UserGroup:');
    console.log(userGroup);

    this.setCurrentUserGroup.emit(userGroup);

    this.showDeleteModal(true);

  } // End function buttonDeleteUserGroup

  showDeleteModal(value: boolean) {
    this.deleteModal = value;

  } // End function showDeleteModal

  confirmDeleteUserGroup() {
    this.deleteUserGroup.emit(this.currentUserGroup);
    this.showDeleteModal(false);
  }

  // --------- Detectar tecla presionada
  onKeydown(event: any) {
    // console.log('Presionada tecla...');
    // console.log(event);
    if (event.key === 'Enter') {
      // console.log('--> Tecla ENTER.');

      this.buttonGetUserGroupList();
    }
  } // End function onKeydown

  // Función que ordena el listado de elementos.
  onSorted(event: any) {
    console.log('--> onSorted Tabla directiva lanzada:');
    console.log(event);

    // console.log(' -> Columna a ordenar: ' + event.sortColumn);
    // console.log(' -> Dirección orden: ' + event.sortDirection);
    // console.log(' -> Es número: ' + event.isNumeric);

    // Si hubiese que realizar alguna acción específica para la columna seleccionada.
    // switch (event.sortColumn) {
    //   case 'mat_desc':
    //     break;

    //   case 'lagm_platz':
    //     break;
    // }

    // Se lanza la función de ordenación del array de inventario.
    // Modifica directamente el array pasado como primer parámetro.
    // NOTA: el nombre de la columna, al ser para ORACLE, tendrá que estar en mayúsculas.
    this.userGroups = fromSortableColumn.sortByColumn(
      this.userGroups, this.dbt.t(event.sortColumn), event.sortDirection, event.isNumeric);

    console.log('--> Array userGroups  de la ordenación:');
    console.log(this.userGroups);

  } // End function onSorted

} // End class UserGroupListComponent
